import { Injectable } from '@angular/core';
import { DisponibilidadGeneralHelperService } from './disponibilidad-general-helper.service';

/**
 * Service for mapping and normalizing unit types
 * Uses the same threshold-key mapping as Disponibilidad General (and Operaciones)
 * so the Pronóstico de Disponibilidad counts units against the same categories.
 */
@Injectable()
export class UnitTypeMapperService {

    constructor(private disponibilidadGeneralHelper: DisponibilidadGeneralHelperService) { }

    /**
     * Normalizes a unit type to its threshold key
     * @param rawTipo Full unit key from database (e.g. "Vehículo ejecutivo - Toyota Camry...") or an already normalized key
     * @returns Normalized unit type (e.g., "AUTOS", "TIPO 2 LUJO")
     */
    normalizeTipoUnidad(rawTipo: string): string {
        const cleaned = (rawTipo || '').toUpperCase().trim();
        if (this.getAllUnitTypes().indexOf(cleaned) !== -1) {
            return cleaned;
        }

        return this.disponibilidadGeneralHelper.mapUnitTypeToThresholdKey(rawTipo) || cleaned;
    }

    /**
     * Checks if unidadesSolicitadas object matches the selected unit type
     * @param unidadesSolicitadas Object with unit types and quantities
     * @param selectedTipo The unit type to match against
     * @returns True if any unit in unidadesSolicitadas matches selectedTipo
     */
    matchesSelectedTipo(unidadesSolicitadas: any, selectedTipo: string): boolean {
        return this.countMatchingUnits(unidadesSolicitadas, selectedTipo) > 0;
    }

    /**
     * Counts the total number of units that match the selected unit type
     * @param unidadesSolicitadas Object with unit types and quantities
     * @param selectedTipo The unit type to match against
     * @returns Total count of matching units
     */
    countMatchingUnits(unidadesSolicitadas: any, selectedTipo: string): number {
        if (!unidadesSolicitadas) {
            return 0;
        }

        let totalCount = 0;
        const normalized = this.normalizeTipoUnidad(selectedTipo);

        for (const k in unidadesSolicitadas) {
            if (!unidadesSolicitadas.hasOwnProperty(k)) {
                continue;
            }
            const v = unidadesSolicitadas[k];

            if (!(v > 0)) {
                continue;
            }

            // Map the FULL key so Lujo variants are identified correctly
            if (this.normalizeTipoUnidad(k) === normalized) {
                totalCount += v / 1;
            }
        }

        return totalCount;
    }

    /**
     * @returns Array of normalized unit type names
     */
    getAllUnitTypes(): string[] {
        return this.disponibilidadGeneralHelper.getAllUnitTypes();
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/helpers/unit-type-mapper.service.ts